import { useState } from "react";
import { Target, Lightbulb, ChevronDown, ChevronUp } from "lucide-react";

const COMPETITORS = [
  {
    name: "Immobiliare.it (Valutazione)", cat: "Portale leader annunci",
    points: [
      "Range min/medio/max in 3 minuti calcolato su milioni di annunci reali",
      "Grafico storico dell'andamento prezzi €/mq della zona negli anni",
      "Contatto immediato con agenzie locali partner dopo la stima",
    ],
    enea: "ENEA usa OMI ufficiale (prezzi di rogito, non asking gonfiati) — il trend storico di zona è l'idea più forte da copiare.",
  },
  {
    name: "Idealista", cat: "Portale annunci",
    points: [
      "Report di valutazione inviato via email con storico delle richieste",
      "Mappa interattiva dei prezzi per quartiere",
      "Alert automatici quando il valore della zona cambia",
    ],
    enea: "ENEA invia già il PDF via email — mancano mappa prezzi e alert periodici sul valore.",
  },
  {
    name: "RealAdvisor", cat: "Proptech valutazione",
    points: [
      "Modello edonico su 70 criteri (20 immobile + 50 posizione)",
      "Rivalutazione trimestrale automatica: il proprietario resta agganciato nel tempo",
      "Perizia gratuita sul posto con esperti locali come upsell",
    ],
    enea: "ENEA ha 22 fattori tradotti in euro — la rivalutazione automatica periodica è il gancio di retention da implementare.",
  },
  {
    name: "Dove.it", cat: "Agenzia online",
    points: [
      "Vendita a commissione fissa ridotta, messaggio prezzo trasparente",
      "Foto professionali e tour virtuale inclusi nell'incarico",
      "Dashboard venditore con statistiche visite dell'annuncio in tempo reale",
    ],
    enea: "La dashboard venditore post-incarico (visite, contatti, feedback) è un'ottima idea per il protocollo Zero Vincoli.",
  },
  {
    name: "Casavo", cat: "Instant buyer",
    points: [
      "Offerta d'acquisto diretta: vendita chiusa in pochi giorni",
      "Algoritmo su 20+ categorie con visita fisica di conferma",
      "Gestione completa della trattativa con rete di agenti propri",
    ],
    enea: "Zero Vincoli già garantisce acquirenti certificati — un'opzione 'offerta rapida garantita' sarebbe il passo successivo.",
  },
  {
    name: "Wikicasa", cat: "Portale delle agenzie",
    points: [
      "Stime basate su prezzi di transato reali condivisi dalle agenzie",
      "Posizionamento 'dati verificati, non richieste gonfiate'",
      "Report di zona scaricabile gratuitamente",
    ],
    enea: "Stesso posizionamento anti-asking di ENEA: differenziarsi con il rischio di zona calcolato (che loro non hanno).",
  },
  {
    name: "Borsino Immobiliare", cat: "Banca dati quotazioni",
    points: [
      "Quotazioni per micro-zona con serie storiche ventennali",
      "Report professionali a pagamento per periti e tecnici",
      "Indice di appetibilità commerciale della zona",
    ],
    enea: "L'indice di appetibilità zona è affine al nostro rischio di zona: ENEA lo dà gratis nel report — comunicarlo di più.",
  },
  {
    name: "AVM bancari (CRIF, Prelios)", cat: "Valutazioni per mutui",
    points: [
      "Standard EBA riconosciuti dalle banche per i mutui",
      "Rivalutazione automatica del portafoglio immobiliare",
      "Firma del perito abilitato sulla perizia",
    ],
    enea: "ENEA dichiara già la nota metodologica IVS/Tecnoborsa — un badge 'metodologia da perizia' rafforzerebbe la fiducia.",
  },
];

const PRIORITIES = [
  "Trend storico prezzi €/mq della zona nel report (grafico ultimi anni — dati OMI storici già in casa)",
  "Rivalutazione automatica: email trimestrale 'il valore della tua casa è cambiato' per riagganciare i lead",
  "Dashboard venditore Zero Vincoli: stato pratica, acquirenti certificati interessati, prossimi passi",
];

export const CompetitorRadar = () => {
  const [open, setOpen] = useState(null);
  return (
    <div className="space-y-4" data-testid="admin-radar-section">
      <div className="bg-[#0b2545] border border-teal-400/30 rounded-xl p-4">
        <div className="flex items-center gap-2 text-sm font-bold text-teal-300"><Lightbulb className="w-4 h-4" /> Le 3 idee a maggiore impatto da implementare</div>
        <ul className="mt-2 space-y-1.5">
          {PRIORITIES.map((p, i) => (
            <li key={p} className="text-xs text-slate-300 flex items-start gap-2"><span className="text-teal-300 font-bold flex-shrink-0">{i + 1}.</span> {p}</li>
          ))}
        </ul>
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        {COMPETITORS.map((c, i) => (
          <div key={c.name} className="bg-[#0b2545] border border-white/10 rounded-xl p-4" data-testid={`radar-competitor-${i}`}>
            <button onClick={() => setOpen(open === i ? null : i)} className="w-full flex items-start justify-between gap-2 text-left" data-testid={`radar-toggle-${i}`}>
              <div>
                <div className="text-sm font-bold text-white flex items-center gap-2"><Target className="w-3.5 h-3.5 text-teal-300 flex-shrink-0" /> {c.name}</div>
                <div className="text-[10px] uppercase tracking-wider text-slate-400 mt-0.5">{c.cat}</div>
              </div>
              {open === i ? <ChevronUp className="w-4 h-4 text-slate-400 flex-shrink-0" /> : <ChevronDown className="w-4 h-4 text-slate-400 flex-shrink-0" />}
            </button>
            <ul className="mt-3 space-y-1.5">
              {c.points.map((p) => (
                <li key={p} className="text-xs text-slate-300 flex items-start gap-2"><span className="text-teal-300 flex-shrink-0">▸</span> {p}</li>
              ))}
            </ul>
            {open === i && (
              <div className="mt-3 rounded-lg bg-teal-400/10 border border-teal-400/20 px-3 py-2 text-[11px] text-teal-200" data-testid={`radar-enea-${i}`}>
                <b>ENEA vs loro:</b> {c.enea}
              </div>
            )}
          </div>
        ))}
      </div>
      <p className="text-[10px] text-slate-500">Radar aggiornato a giugno 2026 — fonti: siti ufficiali dei competitor e analisi di settore. Le funzionalità elencate sono candidate da valutare per la roadmap di eneaspecialist.it.</p>
    </div>
  );
};

export default CompetitorRadar;
